// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function SpeakerSlashIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M6.74 4.327a1 1 0 1 0-1.48 1.346L9.194 10H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5.656l8.73 6.789A1 1 0 0 0 20 28v-6.114l5.26 5.787a1 1 0 1 0 1.48-1.345l-20-22ZM4 12h5v8H4v-8Zm14 13.955-7-5.444v-8.525l7 7.7v6.269Zm5.25-7.971a3 3 0 0 0 0-3.965 1 1 0 1 1 1.5-1.322 5 5 0 0 1 0 6.61 1 1 0 1 1-1.5-1.323Zm-10.02-9.5a1 1 0 0 1 .175-1.404l4.981-3.875A1 1 0 0 1 20 4v9.354a1 1 0 0 1-2 0V6.045L14.633 8.67a1 1 0 0 1-1.403-.181v-.005ZM31 16a9.988 9.988 0 0 1-2.546 6.668 1 1 0 0 1-1.49-1.334 8 8 0 0 0 0-10.666.999.999 0 1 1 1.49-1.334A9.978 9.978 0 0 1 31 16Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
